import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'

import { NumberField } from '@/ui/form/controls/NumberField'
import { TimeField } from '@/ui/form/controls/TimeField'
import React from 'react'

const DayScheduleContent = ({ data, setData }) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-p-4">
      <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
        <p className="tw-flex-[2] tw-text-sm tw-text-content-base">
          Czas rozpoczęcia pracy
        </p>

        <div className="tw-w-[100px]">
          <TimeField
            required
            value={data?.dayScheduleTime}
            setValue={(e) => setData({ ...data, dayScheduleTime: e })}
          />
        </div>
      </div>
      <div className="tw-flex tw-justify-between tw-items-center tw-gap-2">
        <p className="tw-flex-[2] tw-text-sm tw-text-content-base">
          Plan pracy
        </p>

        <div className="tw-w-[100px]">
          <NumberField
            required
            value={data?.scheduleTime}
            setValue={(e) => setData({ ...data, scheduleTime: e })}
          />
        </div>
      </div>
      <CheckboxWithLabelField
        field="showSchedule"
        data={data}
        setData={setData}
        label={'Tylko dla dni pracujących'}
      />
    </div>
  )
}

export default DayScheduleContent
